import { render, staticRenderFns } from "./PrkBasicInformationAboutSubject.vue?vue&type=template&id=417a5f1c&scoped=true&"
import script from "./PrkBasicInformationAboutSubject.vue?vue&type=script&lang=js&"
export * from "./PrkBasicInformationAboutSubject.vue?vue&type=script&lang=js&"
import style0 from "./PrkBasicInformationAboutSubject.vue?vue&type=style&index=0&id=417a5f1c&scoped=true&lang=scss&"
import style1 from "./PrkBasicInformationAboutSubject.vue?vue&type=style&index=1&id=417a5f1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417a5f1c",
  null
  
)

export default component.exports